








































import { Component, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import TicketSettingListSearch from '@/components/ticketsetting/list/Search.vue';
import TicketSettingListResult from '@/components/ticketsetting/list/Result.vue';
import { formatApiError } from '@/utils/index';
import { translateRouteTitle } from '@/utils/permission';
import { AppModule } from '@/store/modules/app';
import { TicketSetting, IPlanSummaryData } from '@/api/types';
import {
  listTicketSettings,
  IListTicketSettingsRequest,
  listPlans,
  IListPlansRequest,
} from '@/api/tickets';

@Component({
  name: 'TicketSettingList',
  components: {
    MaterialCard,
    TicketSettingListSearch,
    TicketSettingListResult,
  },
})
export default class extends Vue {
  private plans: IPlanSummaryData[] = [];
  private loading = true;
  private tickets: TicketSetting[] = [];
  private searched = false;

  get ticketSettingSearchEvent() {
    return TicketSettingListSearch.ticketSettingSearchEvent;
  }

  get canDisplayResult() {
    return this.tickets && this.tickets.length > 0 && this.searched;
  }

  get canDisplayNoData() {
    return (!this.tickets || this.tickets.length <= 0) && this.searched;
  }

  get noDataText() {
    return this.$t('No {msg}', {
      msg: (this.$t('Ticket setting') as string).toLowerCase(),
    });
  }

  mounted() {
    this.fetchData();
  }

  private async fetchData() {
    AppModule.StartProgress();
    this.loading = true;
    await this.loadPlans();
    this.loading = false;
    AppModule.StopProgress();
  }

  private async loadPlans() {
    try {
      const res = await listPlans({} as IListPlansRequest);
      this.plans = res.plans;
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Plan'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private async handleSearch($event: any) {
    const req: IListTicketSettingsRequest = $event;

    AppModule.StartProgress();

    try {
      const res = await listTicketSettings(req);
      this.tickets = res.tickets;
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }

    this.searched = true;
    this.$nextTick(() => {
      if (this.canDisplayResult) {
        (this.$refs
          .ticketSettingListResult as TicketSettingListResult).loadItems();
      }
    });
    AppModule.StopProgress();
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
